import React from "react";

import { PROJECT_TABS } from "../constants";
import { useProjectPageContext } from "./ProjectPageContext";

/**
 * Render the project tab switcher.
 *
 * @returns {JSX.Element}
 */
const ProjectTabs = () => {
  const { activeTab, setActiveTab } = useProjectPageContext();

  return (
    <nav className="flex w-fit max-w-full overflow-x-auto rounded-xl border border-gray-200 bg-white/80 p-1 shadow-sm shadow-primary-900/5">
      {PROJECT_TABS.map(({ id, label, Icon }) => {
        const isActive = id === activeTab;
        return (
          <button
            key={id}
            type="button"
            onClick={() => setActiveTab(id)}
            aria-current={isActive ? "page" : undefined}
            className={`inline-flex h-10 flex-shrink-0 items-center justify-center gap-2 rounded-lg px-4 text-sm font-semibold transition focus:outline-none focus:ring-4 focus:ring-secondary-100 ${
              isActive
                ? "border border-primary-200 bg-white text-primary shadow-sm"
                : "text-gray-500 hover:bg-gray-50 hover:text-gray-900"
            }`}
          >
            <Icon className="h-4 w-4" />
            {label}
          </button>
        );
      })}
    </nav>
  );
};

export default ProjectTabs;
